import {
	city,
	internationalPhoneNumber,
	phoneNumber,
	state,
	streetName,
	streetNumber,
	zipcode,
} from '#base/core/consts/companyData';
import { generalMail } from '#fit/core/consts/companyData';
import { facebookPageUrl, instagramPageUrl, threadsPageUrl } from '#fit/core/consts/socialMediaPages';
import type { JobPostingEmploymentType } from '#base/core/enums/JobPostingEmploymentTypeEnum';
import type { PriceType } from '#base/core/types/PriceType';
import { schemaContext, formatSchema } from '#base/helpers/schemaHelpers';

export const openingHoursSchema = () => {
	return [
		'Mo,We,Th 08:30-21:00',
		'Tu,Fr 08:30-18:00',
		'We,Th 08:30-21:00',
		'Sa 08:30-13:00',
	];
};

/**
 * GENERAL SCHEMA'S
 */

export const addressSchema = {
	'@type': 'PostalAddress',
	'addressLocality': city,
	'postalCode': zipcode,
	'streetAddress': `${streetName} ${streetNumber}`,
	'addressCountry': 'NL',
	'addressRegion': state,
	'telephone': phoneNumber,
	'email': generalMail,
};

export const organizationSchema = {
	...schemaContext,
	'@type': 'Organization',
	'address': addressSchema,
	'sameAs': [facebookPageUrl, instagramPageUrl, threadsPageUrl],
	'name': 'Fit Hier',
	'logo': 'https://fithier.com/img/logo/fit-hier-icon-center-dark@2x.png',
	'url': 'https://www.fithier.com',
	'contactPoint': {
		'@type': 'ContactPoint',
		'telephone': internationalPhoneNumber,
		'contactType': 'Customer Service',
		'areaServed': 'NL',
		'availableLanguage': [
			{
				'@type': 'Language',
				'name': 'Dutch',
			},
			{
				'@type': 'Language',
				'name': 'English',
			},
		],
	},
};

export const localBusinessSchema = {
	...organizationSchema,
	'@type': 'LocalBusiness',
	'currenciesAccepted': 'EUR',
	'openingHours': openingHoursSchema(),
};

export const excersiseGymSchema = {
	...localBusinessSchema,
	'@type': 'ExerciseGym',
	'priceRange': '$$',
	'image': [
		'https://fithier.com/img/schema-images/slee_04.jpg',
		'https://fithier.com/img/schema-images/sportruimte-rechtsvoor_01.jpg',
	],
};

/**
 * SPORT SCHEMA'S
 */

export const subscriptionGroupSchema = (
	name: string,
	description: string,
	url: string,
	price?: PriceType,
) =>
	formatSchema({
		...schemaContext,
		'@type': 'Offer',
		name,
		description,
		'priceSpecification': {
			'@type': 'UnitPriceSpecification',
			'price': price?.value,
			'priceCurrency': 'EUR',
			'unitText': price?.subject,
		},
		url,
	});

/**
 * JOB POSTINGS
 */

export const jobPostingSchema = (
	title: string,
	description: string,
	datePosted: string,
	employmentTypes: JobPostingEmploymentType[],
) =>
	formatSchema({
		...schemaContext,
		'@type': 'JobPosting',
		title,
		description,
		'jobLocation': {
			'@type': 'Place',
			'address': addressSchema,
		},
		datePosted,
		'hiringOrganization': organizationSchema,
		'employmentType': employmentTypes,
	});
